import './CreateSuccess.scss';
export class CreatSuccessController {
    static $inject = ['TenantService', '$stateParams', 'PORTALDOMAIN', 'BlipToastService', '$translate'];
    constructor(TenantService, $stateParams, PORTALDOMAIN, BlipToastService, $translate) {
        'ngInject';
        this.TenantService = TenantService;
        this.$stateParams = $stateParams;
        this.PORTALDOMAIN = PORTALDOMAIN;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.goToTenant = () => {
            window.location.href = this.TenantService.getTenantUrl(this.tenantId);
        };
        const { id, name, invitationsSent } = this.$stateParams;
        this.tenantId = id;
        this.tenantName = name;
        this.invitationsSent = invitationsSent;
    }
    async $onInit() {
        this.tenantLink = `${this.tenantId}.${this.PORTALDOMAIN}`.toLowerCase();
        if (this.invitationsSent) {
            this.BlipToastService.show('success', {
                msg: await this.$translate('create-success.invitationSentSuccess', {}),
                duration: 6000,
            });
        }
    }
}
CreatSuccessController.$inject = ['TenantService', '$stateParams', 'PORTALDOMAIN', 'BlipToastService', '$translate'];
